/*
 * Cosa vede il cliente quando un componente si rompe davvero.
 *
 * Senza una rete di sicurezza React smonta l'albero e resta una pagina bianca:
 * il cliente non sa se ha sbagliato lui, se la sessione è scaduta o se è un
 * guasto, e apre un ticket che dice "non funziona niente". Qui si dice cosa è
 * successo, si offre la via d'uscita e si mostra il codice dell'evento, che è
 * l'unico modo per collegare quello che ha visto lui a quello che vediamo noi.
 */
import React from 'react';
import { makeStyles, tokens, Text, Button, FluentProvider, webLightTheme } from '@fluentui/react-components';
import { ErrorCircle48Regular, ArrowClockwise20Regular } from '@fluentui/react-icons';

const useStyles = makeStyles({
  wrap: {
    minHeight: '60vh', display: 'flex', flexDirection: 'column', alignItems: 'center',
    justifyContent: 'center', gap: '12px', padding: '32px', textAlign: 'center',
  },
  icona: { color: tokens.colorPaletteRedForeground1 },
  sub: { color: tokens.colorNeutralForeground3, maxWidth: '520px' },
  azioni: { display: 'flex', gap: '8px', marginTop: '8px' },
  codice: {
    fontFamily: tokens.fontFamilyMonospace, fontSize: tokens.fontSizeBase200,
    color: tokens.colorNeutralForeground3, marginTop: '10px',
    userSelect: 'all',
  },
});

export default function ErroreFatale({ error, eventId, resetError }) {
  const s = useStyles();
  /* Il provider se lo porta dietro: in quest'app FluentProvider sta dentro
     Layout, e la schermata d'errore compare proprio quando Layout non è
     riuscito a montarsi. Senza, i token non si risolvono e resta scolorita. */
  return (
    <FluentProvider theme={webLightTheme}>
    <div className={s.wrap}>
      <ErrorCircle48Regular className={s.icona} />
      <Text as="h1" size={600} weight="semibold">Questa schermata si è interrotta</Text>
      <Text className={s.sub}>
        Il problema è stato registrato e lo stiamo vedendo. Puoi riprovare: se si ripresenta,
        riferisci all&apos;assistenza il codice qui sotto.
      </Text>
      <div className={s.azioni}>
        <Button appearance="primary" icon={<ArrowClockwise20Regular />} onClick={resetError}>Riprova</Button>
        <Button onClick={() => { window.location.href = '/'; }}>Torna alla home</Button>
      </div>
      {eventId && <div className={s.codice}>Codice evento: {eventId}</div>}
      {process.env.NODE_ENV !== 'production' && error?.message && (
        <div className={s.codice}>{String(error.message)}</div>
      )}
    </div>
    </FluentProvider>
  );
}
